import { Time } from '../../../../../../assets/icon/iconify'
import { formatCountDown } from '../../../../../../utils/format-date-time-message.utils';

export interface CountdownTime  {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

export interface TimeInfo extends CountdownTime {
    expired: boolean;
}

interface Props {
    isExpired: boolean;
    timeLeft: TimeInfo;
}

export default function ProposalCountDown({ isExpired, timeLeft } : Props) {

    return (
        <div className="flex shrink-0 items-center gap-1.5 rounded-md border border-orange-200 bg-orange-50 px-2.5 py-1.5 text-orange-700">
            <Time size={14} />
            <span className="whitespace-nowrap text-[9px] font-medium sm:text-[10px]">
                {isExpired ? 'Expired' : formatCountDown(timeLeft)}
            </span>
        </div>
    );
}